export const PRODUCTION_TIME_ZONE = 'Asia/Tashkent'; // lol
